import ms from 'ms';
import { useEffect, useState } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getIsBidderCardValid } from '@/redux/modules/account/payments/creditCard/cardStatus/bidderCardStatus.selectors';
import {
    getANMS,
    getBidderEmail,
    getBidderId,
    getUserFullName,
    isProfileComplete,
} from '@/redux/modules/account/user/user.selectors';
import { getClientIpAddress, getUserAgent, isE2ETest } from '@/redux/modules/browser';
import { getBuildNumber } from '@/redux/modules/config';

import tracker from './tracker';

const OpenReplay = () => {
    const [startLogging, setStartLogging] = useState(false);

    const isRunningE2eTest = useAppSelector(isE2ETest);

    // Get data to identify user
    const ANMS = useAppSelector(getANMS);
    const bidderId = useAppSelector(getBidderId);
    const creditCardValidated = useAppSelector(getIsBidderCardValid);
    const email = useAppSelector(getBidderEmail);
    const fullName = useAppSelector(getUserFullName);
    const profileComplete = useAppSelector(isProfileComplete);
    const buildNumber = useAppSelector(getBuildNumber);
    const ipAddress = useAppSelector(getClientIpAddress);
    const userAgent = useAppSelector(getUserAgent);

    /**
     * Set flag to initialize OpenReplay to start recording session
     */
    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;

        // Don't init OpenReplay in local dev or cypress tests, begin recording session after 10 seconds
        if (!__DEVELOPMENT__ && !isRunningE2eTest) {
            if (!timer) {
                timer = setTimeout(() => {
                    setStartLogging(true);
                }, ms('10s'));
            }
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // If not in development mode or running tests and the user is loaded
    // start recording to OpenReplay and identify user
    useEffect(() => {
        if (process.env.NODE_ENV !== 'development' && process.env.CI !== 'true') {
            if (startLogging && !tracker.isActive()) {
                try {
                    tracker
                        .start({
                            metadata: {
                                ANMS: `${ANMS}`,
                                buildNumber,
                                email,
                                IPAddress: ipAddress,
                                name: fullName,
                                profileComplete: `${profileComplete}`,
                                userAgent,
                            },
                            userID: `${bidderId}`,
                        })
                        .catch((error) => {
                            console.error('openreplay error', error);
                        });
                } catch (error) {
                    console.error('openreplay error', error);
                }
            }
        }
    }, [
        ANMS,
        bidderId,
        creditCardValidated,
        email,
        fullName,
        ipAddress,
        profileComplete,
        buildNumber,
        startLogging,
        userAgent,
    ]);

    return null;
};

export default OpenReplay;
